import { useSelector } from 'react-redux';
import { Root, useRoleAssumptionSelector } from '@makemydeal/dr-activities-role-assumption';
import type { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import * as dealValidationSelectors from '@makemydeal/dr-dash-store/selectors/dealValidationSelectors';
import { isRoleAssumptionLoading, isUserInvalidForRoleAssumption } from '@makemydeal/dr-dash-store/utils/roleAssumptionUtils';
import { useRoleAssumptionNavigation } from '@makemydeal/dr-dash-store/hooks/useRoleAssumptionNavigation';
import { LoadingPage } from '@makemydeal/dr-dash-components';
import { useDealershipSelector } from '@makemydeal/dr-activities-dealership-picker';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { Snackbar } from '@interstate/components/Snackbar';
import { NO_DEALERSHIP_ASSOCIATED_MESSAGE, ROLE_ASSUMPTION_ROOT_ROUTE } from '../constants';
import { getRoleAssumptionSelectors } from '../config';
import { RoleAssumptionContainerStyle } from './RoleAssumptionContainer.style';

export const RoleAssumptionContainer = () => {
    useRoleAssumptionNavigation();

    const { dealerships, requestStatus } = useDealershipSelector();
    const isEmployee = useSelector(dealValidationSelectors.getIsEmployee);
    const isDealValid = useSelector(dealValidationSelectors.isDealValid);
    const { enableRoleAssumptionInMV } = useSelector(featureToggleSelectors.getFeatureToggles);
    const selectors = getRoleAssumptionSelectors();

    const { assumedUserName, isNoDealAssociated } = useRoleAssumptionSelector();

    const isUserInvalid = isNoDealAssociated
        ? true
        : isUserInvalidForRoleAssumption(
              isEmployee,
              enableRoleAssumptionInMV!,
              requestStatus as ApiRequestStatus,
              dealerships,
              isDealValid
          );
    const isLoading = isRoleAssumptionLoading(
        isEmployee,
        enableRoleAssumptionInMV!,
        requestStatus as ApiRequestStatus,
        assumedUserName
    );

    if (isLoading) {
        return <LoadingPage />;
    }
    return (
        <RoleAssumptionContainerStyle>
            <Snackbar
                data-testid="invalid-user-role-snackbar"
                show={isUserInvalid}
                message={NO_DEALERSHIP_ASSOCIATED_MESSAGE}
                position="bottom-center"
                type="error"
            />
            <Root baseRoute={ROLE_ASSUMPTION_ROOT_ROUTE} selectors={selectors} />
        </RoleAssumptionContainerStyle>
    );
};
